// Tremor Textarea [v1.0.0]

import React from "react"

import { cx, focusInput, hasErrorInput } from "@/lib/utils"

interface TextareaProps
    extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'required'> {
    hasError?: boolean
    required?: boolean | { required: boolean; message: string };
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, hasError, required = false, ...props }: TextareaProps, forwardedRef) => {
        return (
            <textarea
                ref={forwardedRef}
                className={cx(
                    // base
                    "block w-full appearance-none rounded-md border-0 px-2.5 py-1.5 shadow-xs outline-hidden transition sm:text-sm min-h-[4rem]",
                    // text color
                    "text-gray-900",
                    // placeholder color
                    "placeholder-gray-400",
                    // background color
                    "bg-[#f3f3f5]",
                    // disabled
                    "disabled:border-gray-300 disabled:bg-gray-100 disabled:text-gray-400",
                    // focus
                    "focus:border-[#079a95] focus:ring-2 focus:ring-[#079a95]/20",
                    // error
                    hasError ? hasErrorInput : "",
                    className,
                )}
                tremor-id="tremor-raw"
                {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
            />
        )
    },
)

Textarea.displayName = "Textarea"

export { Textarea, type TextareaProps }